





















































import { v4 as uuid } from "uuid";
import { computed, defineComponent } from "@vue/composition-api";

import { Item } from "@/tools/msa/models/item";
import { Page, Session, Token } from "@/tools/msa/models";
import BaseSection from "@/tools/msa/components/document/BaseSection.vue";
import {
  appendToPreviousDocument,
  prependToNextDocument,
  splitDocument
} from "@/tools/msa/utils/splitting/documents";

interface Props {
  index: number;
  map: Map<Token, Item[]>;
  session: Session;
  page: Page;
  isLast: boolean;
  selected: Item | null;
}

export default defineComponent<Props>({
  name: "BasePage",
  components: { BaseSection },
  props: {
    index: { type: Number, required: true },
    map: { type: Map, required: true },
    page: { type: Object, required: true },
    session: { type: Object, required: true },
    isLast: { type: Boolean, default: false },
    selected: { type: Object, required: false }
  },
  setup(props: Props, context) {
    const lastPageNumber = computed(() =>
      Math.max(
        ...props.session.documents
          .flatMap(document => document.pages)
          .map(page => page.number)
      )
    );

    const mergeWithAbove = (index: number) => {
      props.page.sections.splice(index - 1, 2, {
        id: uuid(),
        page: props.page,
        tokens: [
          ...props.page.sections[index - 1].tokens,
          ...props.page.sections[index].tokens
        ],
        included: props.page.sections[index - 1].included
      });

      context.emit("changed-section");
    };

    return {
      lastPageNumber,
      mergeWithAbove,
      splitDocument,
      appendToPreviousDocument,
      prependToNextDocument
    };
  }
});
